module.exports = __webpack_public_path__ + "static/media/download-green.2f70a7b3.svg";